import { Consent, select } from "@fruugo/utilities";
import { i18n } from "../../i18n";
import { updateConsents } from "../../consent";
import { closeModal } from "./Modal";

type ManageConsentScreenProps = {
  consents: Consent;
  handleAcceptAll: () => void;
  handleDeclineAll: () => void;
};

export const ManageConsentScreen = ({
  consents,
  handleAcceptAll,
  handleDeclineAll,
}: ManageConsentScreenProps) => {
  return (
    <>
      <article class="p-16">
        <h2 className="h3 fw-bold">{i18n("consent.modal.customise.title")}</h2>
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="h4 fw-bold">
            {i18n("consent.modal.customise.option-1.title")}
          </h3>
          <p className="text-muted">
            {i18n("consent.modal.customise.option-1.title.note")}
          </p>
        </div>
        <p>{i18n("consent.modal.customise.option-1.description-1")}</p>
        <p>{i18n("consent.modal.customise.option-1.description-2")}</p>
        <div class="switch mb-16">
          <input
            type="checkbox"
            id="cookie-analytics"
            checked={consents.analytics}
          />
          <label htmlFor="cookie-analytics">
            <h3 class="mb-0 h4 fw-bold">
              {i18n("consent.modal.customise.option-2.title")}
            </h3>
            <span></span>
          </label>
        </div>
        <p>{i18n("consent.modal.customise.option-2.description-1")}</p>
        <p>{i18n("consent.modal.customise.option-2.description-2")}</p>
        <div class="switch mb-16">
          <input
            type="checkbox"
            id="cookie-advertising"
            checked={consents.advertising}
          />
          <label htmlFor="cookie-advertising">
            <h3 class="mb-0 h4 fw-bold">
              {i18n("consent.modal.customise.option-3.title")}
            </h3>
            <span></span>
          </label>
        </div>
        <p>{i18n("consent.modal.customise.option-3.description-1")}</p>
        <p class="mb-0">
          {i18n("consent.modal.customise.option-3.description-2")}
        </p>
      </article>
      <div class="p-16 d-flex flex-column flex-sm-row-reverse gap-4">
        <button class="button button-blue" onClick={handleAcceptAll}>
          {i18n("consent.modal.action.accept")}
        </button>
        <button class="button button-secondary" onClick={handleSaveAndClose}>
          {i18n("consent.modal.action.allow-selection")}
        </button>
        <button class="button button-secondary" onClick={handleDeclineAll}>
          {i18n("consent.modal.action.reject")}
        </button>
      </div>
    </>
  );
};

const handleSaveAndClose = () => {
  const analyticsInput = select<HTMLInputElement>("#cookie-analytics");
  const advertisingInput = select<HTMLInputElement>("#cookie-advertising");

  const analyticsInputChecked = analyticsInput ? analyticsInput.checked : false;
  const advertisingInputChecked = advertisingInput
    ? advertisingInput.checked
    : false;

  const consent: Consent = {
    essential: true,
    analytics: analyticsInputChecked,
    advertising: advertisingInputChecked,
  };

  updateConsents(consent);
  closeModal();
};
